"use strict";

/**
 *  平台设置
 *  @module 天空盒属性
 */

import Vue from "@/main";
import * as mapSkyBox from "@/components/common/skyBox/map";
import * as mapSkyBoxClone from "@/components/tables/compare/map";

// 默认数据
const form = {
  skyBox: "0", //天空盒
};

// 保存提交 (存储至localStorage)
const saveSkyBoxSettings = (data) => {
  localStorage.setItem("skyBoxSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureSkyBoxSettings = () => {
  if (localStorage.getItem("skyBoxSettings")) {
    return JSON.parse(localStorage.getItem("skyBoxSettings"));
  } else {
    localStorage.setItem("skyBoxSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setSkyBoxEffect = (data, map = Vue.$GLOBAL.map) => {
  const { skyBox } = data;
  mapSkyBox.skyBoxToUpdate(skyBox);
  mapSkyBoxClone.skyBoxToUpdate(skyBox);
};

export { saveSkyBoxSettings, exposureSkyBoxSettings, setSkyBoxEffect };
